var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHamburger(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient_0",
    gradientUnits: "userSpaceOnUse",
    x1: 1.4610146e-13,
    y1: 9.6428576,
    x2: 31.709999,
    y2: 9.6428576
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8334FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48380247,
    stopColor: "#BD88FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8334FF"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#gradient_0)",
    d: "M30.51 16.857143L15.21 16.857143C14.548272 16.857143 14.01 17.399923 14.01 18.071428C14.01 18.742893 14.548298 19.285715 15.21 19.285715L30.51 19.285715C31.171741 19.285715 31.709999 18.742918 31.709999 18.071428C31.709999 17.399899 31.171768 16.857143 30.51 16.857143ZM30.51 8.4285717L1.2 8.4285717C0.53825778 8.4285717 0 8.9713669 0 9.6428576C0 10.314388 0.53823179 10.857142 1.2 10.857142L30.51 10.857142C31.171768 10.857142 31.709999 10.314388 31.709999 9.6428576C31.709999 8.9713669 31.171741 8.4285717 30.51 8.4285717ZM30.51 0L8.4099998 0C7.7482319 0 7.21 0.54275471 7.21 1.2142857C7.21 1.8857758 7.7482576 2.4285715 8.4099998 2.4285715L30.51 2.4285715C31.171768 2.4285715 31.709999 1.8858167 31.709999 1.2142857C31.709999 0.54275471 31.171768 0 30.51 0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburger);
export default __webpack_public_path__ + "static/media/hamburger.975f8d736e445baacdb330822a43ad9d.svg";
export { ForwardRef as ReactComponent };